<template>
  <div class="seomain">
    <div class="userinfo_wrap">
      <div class="userinfo_content">
        <div class="left">
          <div class="avatar"><img :src="userinfo.avatar" alt="" /></div>
        </div>
        <div class="middle">
          <div class="name">{{ userinfo.username }}</div>
          <div class="desc">
            <span> {{ userinfo.supervisortypedata || "暂无数据" }} </span>
          </div>
        </div>
        <!-- <div class="right">
          <i class="iconfont icon-jiantouarrow487"></i>
        </div> -->
      </div>
    </div>

    <section class="options_wrap" v-if="firstPageDataList.purchase">
      <!-- 采购管理 -->
      <div v-if="purchaseShow">
        <el-row class="bt_color_y">
          <el-col :span="24" class="title">采购管理</el-col>
        </el-row>
        <el-row type="flex" class="options_content">
          <el-col :span="8" class="item" v-if="this.firstPageDataList.purchase.order == 1">
            <router-link to="shopping/list">
              <div class="icon_wrap">
                <i class="iconfont icon-gouwuche color_y"></i>
              </div>
              <div class="text">我的采购单</div>
            </router-link>
          </el-col>
          <el-col :span="8" class="item" v-if="firstPageDataList.purchase.price == 1">
            <router-link to="purchasec/list">
              <div class="icon_wrap">
                <i class="iconfont icon-shuqian color_y"></i>
              </div>
              <div class="text">采购价维护</div>
            </router-link>
          </el-col>
          <el-col :span="8" class="item" v-if="firstPageDataList.purchase.supplier == 1">
            <router-link to>
              <div class="icon_wrap">
                <i class="iconfont icon-icon-test color_y"></i>
              </div>
              <div class="text">我的供应商</div>
            </router-link>
          </el-col>
        </el-row>
      </div>
      <!-- 库存管理 -->
      <div v-if="inventoryShow">
        <el-row class="bt_color_b">
          <el-col :span="24" class="title">库存管理</el-col>
        </el-row>
        <el-row type="flex" class="options_content">
          <el-col :span="8" class="item" v-if="firstPageDataList.inventory.pruchase_in == 1">
            <router-link to="purchase/list">
              <div class="icon_wrap">
                <i class="iconfont icon-caigouruku-lan color_b"></i>
              </div>
              <div class="text">采购入库</div>
            </router-link>
          </el-col>
          <el-col :span="8" class="item" v-if="firstPageDataList.inventory.transfer_out == 1">
            <router-link to="transfero/list">
              <div class="icon_wrap">
                <i class="iconfont icon-fj_qifei_a color_b"></i>
              </div>
              <div class="text">调拨出库</div>
            </router-link>
          </el-col>
          <el-col :span="8" class="item" v-if="firstPageDataList.inventory.transfer_in == 1">
            <router-link to="transfer/list">
              <div class="icon_wrap">
                <i class="iconfont icon-jiangluo color_b"></i>
              </div>
              <div class="text">调拨入库</div>
            </router-link>
          </el-col>
          <el-col :span="8" class="item" v-if="firstPageDataList.inventory.process == 1">
            <router-link to="process/list">
              <div class="icon_wrap">
                <i class="iconfont icon-jiagong color_b"></i>
              </div>
              <div class="text">加工</div>
            </router-link>
          </el-col>
          <el-col :span="8" class="item" v-if="firstPageDataList.inventory.disassembly == 1">
            <router-link to="disassembly/list">
              <div class="icon_wrap">
                <i class="iconfont icon-chaifen color_b"></i>
              </div>
              <div class="text">拆工</div>
            </router-link>
          </el-col>
          <el-col :span="8" class="item" v-if="firstPageDataList.inventory.sales_out == 1">
            <router-link to="saleo/list">
              <div class="icon_wrap">
                <i class="iconfont icon-chanchengpinxiaoshouchuku color_b"></i>
              </div>
              <div class="text">销售出库</div>
            </router-link>
          </el-col>
          <el-col :span="8" class="item" v-if="firstPageDataList.inventory.process_in == 1">
            <router-link to="processc/list">
              <div class="icon_wrap">
                <i class="iconfont icon-ruku1 color_b"></i>
              </div>
              <div class="text">加工入库</div>
            </router-link>
          </el-col>
          <el-col :span="8" class="item" v-if="firstPageDataList.inventory.disassembly_in == 1">
            <router-link to="disassemblyc/list">
              <div class="icon_wrap">
                <i class="iconfont icon-ruku color_b"></i>
              </div>
              <div class="text">拆工入库</div>
            </router-link>
          </el-col>
          <el-col :span="8" class="item" v-if="firstPageDataList.inventory.inventory == 1">
            <router-link to="inventory/list">
              <div class="icon_wrap">
                <i class="iconfont icon-pandianguanli color_b"></i>
              </div>
              <div class="text">盘点管理</div>
            </router-link>
          </el-col>
          <el-col :span="8" class="item" v-if="firstPageDataList.inventory.picking == 1">
            <router-link to="material/list">
              <div class="icon_wrap">
                <i class="iconfont icon-chuku1 color_b"></i>
              </div>
              <div class="text">仓管备料</div>
            </router-link>
          </el-col>
          <el-col :span="8" class="item" v-if="firstPageDataList.inventory.signing == 1">
            <router-link to="receive/list">
              <div class="icon_wrap">
                <i class="iconfont icon-qianshou color_b"></i>
              </div>
              <div class="text">签收确认</div>
            </router-link>
          </el-col>
          <el-col :span="8" class="item" v-if="firstPageDataList.inventory.inventory_administration == 1">
            <router-link to="inventoryMgt">
              <div class="icon_wrap">
                <i class="iconfont icon-statistic-right2 color_b"></i>
              </div>
              <div class="text">库存统计</div>
            </router-link>
          </el-col>
          <el-col :span="8" class="item" v-if="firstPageDataList.inventory.inventory_assets == 1">
            <router-link to="inventoryAsset">
              <div class="icon_wrap">
                <i class="iconfont icon-zichan color_b"></i>
              </div>
              <div class="text">库存资产</div>
            </router-link>
          </el-col>
          <el-col :span="8" class="item" v-if="firstPageDataList.inventory.inventory_cost == 1">
            <router-link to="inventoryCost">
              <div class="icon_wrap">
                <i class="iconfont icon-chengben color_b"></i>
              </div>
              <div class="text">库存成本</div>
            </router-link>
          </el-col>

          <el-col :span="8" class="item" v-if="firstPageDataList.inventory.sku_pur == '1'">
            <router-link to="skuPurchaseList">
              <div class="icon_wrap">
                <i class="iconfont icon-caigoubaobiao color_b"></i>
              </div>
              <div class="text">SKU采购列表</div>
            </router-link>
          </el-col>
          <el-col :span="8" class="item" v-if="firstPageDataList.inventory.sku_sale == '1'">
            <router-link to="skuSalesList">
              <div class="icon_wrap">
                <i class="iconfont icon-taocanxiaoshoubaobiao color_b"></i>
              </div>
              <div class="text">SKU销售列表</div>
            </router-link>
          </el-col>
        </el-row>
      </div>
      <!-- 销售管理 -->
      <div v-if="salesShow">
        <el-row class="bt_color_g">
          <el-col :span="24" class="title">销售管理</el-col>
        </el-row>
        <el-row type="flex" class="options_content">
          <el-col :span="8" class="item" v-if="firstPageDataList.sales.list == 1">
            <router-link to="sale/list/0">
              <div class="icon_wrap">
                <i class="iconfont icon-zerenqingdan color_y"></i>
              </div>
              <div class="text">我的销售单</div>
            </router-link>
          </el-col>
          <el-col :span="8" class="item" v-if="firstPageDataList.sales.statistics == 1">
            <router-link to="salecmp">
              <div class="icon_wrap">
                <i class="iconfont icon-report color_y"></i>
              </div>
              <div class="text">订单统计</div>
            </router-link>
          </el-col>
          <el-col :span="8" class="item" v-if="firstPageDataList.sales.customer == 1">
            <router-link to>
              <div class="icon_wrap">
                <i class="iconfont icon-lianhe4 color_y"></i>
              </div>
              <div class="text">我的客户</div>
            </router-link>
          </el-col>
          <el-col :span="8" class="item" v-if="firstPageDataList.sales.hire_list == 1">
            <router-link to="sale/list/1">
              <div class="icon_wrap">
                <i class="iconfont icon-icon- color_y"></i>
              </div>
              <div class="text">我的租赁单</div>
            </router-link>
          </el-col>
          <el-col :span="8" class="item" v-if="firstPageDataList.sales.hire_statistics == 1">
            <router-link to="leasecmp">
              <div class="icon_wrap">
                <i class="iconfont icon-tongji color_y"></i>
              </div>
              <div class="text">租赁统计</div>
            </router-link>
          </el-col>
          <el-col :span="8" class="item">
            <router-link to="sale/list/2">
              <div class="icon_wrap">
                <i class="iconfont icon-overseas-orders color_y"></i>
              </div>
              <div class="text">我的海外单</div>
            </router-link>
          </el-col>
          <el-col :span="8" class="item">
            <router-link to="sale/list/3">
              <div class="icon_wrap">
                <i class="iconfont icon-icon color_y"></i>
              </div>
              <div class="text">我的寄售单</div>
            </router-link>
          </el-col>
          <el-col :span="8" class="item">
            <router-link to="sale/list/4">
              <div class="icon_wrap">
                <i class="iconfont icon-invest_manage color_y"></i>
              </div>
              <div class="text">我的投资单</div>
            </router-link>
          </el-col>
        </el-row>
      </div>
      <!-- 统计管理 -->
      <div v-if="statisticsShow">
        <el-row class="bt_color_b">
          <el-col :span="24" class="title">统计管理</el-col>
        </el-row>
        <el-row type="flex" class="options_content">
          <el-col :span="8" class="item" v-if="this.firstPageDataList.statistics.purchasing_buyer == 1">
            <router-link to="dataReport/buyer">
              <div class="icon_wrap">
                <i class="iconfont icon-kehutongji1 color_b"></i>
              </div>
              <div class="text">采购员统计</div>
            </router-link>
          </el-col>
          <el-col :span="8" class="item" v-if="firstPageDataList.statistics.purchasing_supplier == 1">
            <router-link to="dataReport/supplier">
              <div class="icon_wrap">
                <i class="iconfont icon-caigoutongji color_b"></i>
              </div>
              <div class="text">采购供应商统计</div>
            </router-link>
          </el-col>
          <el-col :span="8" class="item" v-if="firstPageDataList.statistics.sale_client == 1">
            <router-link to="dataReport/customer">
              <div class="icon_wrap">
                <i class="iconfont icon-kehutongji color_b"></i>
              </div>
              <div class="text">销售客户统计</div>
            </router-link>
          </el-col>
          <el-col :span="8" class="item" v-if="firstPageDataList.statistics.sale_seller == 1">
            <router-link to="dataReport/sale">
              <div class="icon_wrap">
                <i class="iconfont icon-a color_b"></i>
              </div>
              <div class="text">销售团队统计</div>
            </router-link>
          </el-col>
          <el-col :span="8" class="item" v-if="true">
            <router-link to="leaseReport/customer">
              <div class="icon_wrap">
                <i class="iconfont icon-kehutongji color_b"></i>
              </div>
              <div class="text">租赁客户统计</div>
            </router-link>
          </el-col>
          <el-col :span="8" class="item" v-if="true">
            <router-link to="leaseReport/lease">
              <div class="icon_wrap">
                <i class="iconfont icon-a color_b"></i>
              </div>
              <div class="text">租赁团队统计</div>
            </router-link>
          </el-col>
        </el-row>
      </div>
      <!-- 培训答题 -->
      <div v-if="trainShow">
        <el-row class="bt_color_g">
          <el-col :span="24" class="title">培训考试</el-col>
        </el-row>
        <el-row type="flex" class="options_content">
          <el-col :span="8" class="item" v-if="firstPageDataList.train.train_index == 1">
            <a @click="goToExam">
              <div class="icon_wrap">
                <i class="iconfont icon-zerenqingdan color_y"></i>
              </div>
              <div class="text">培训考试</div>
            </a>
          </el-col>
        </el-row>
      </div>
    </section>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { REDIRECT_URI, SERVER } from "../../../config/global.js";
export default {
  data() {
    return {
      queryObj: {},
      userinfo: {
        username: "",
        supervisortypedata: "",
        avatat: "",
      }, // 用户信息
      // 页面权限配置数据
      firstPageDataList: {
        purchase: {
          order: 0,
          price: 0,
          supplier: 0,
        },
        inventory: {
          pruchase_in: 0,
          transfer_in: 0,
          transfer_out: 0,
          process: 0,
          disassembly: 0,
          sales_out: 0,
        },
        sales: {
          list: 0,
          statistics: 0,
          customer: 0,
        },
        statistics: {
          purchasing_buyer: 0,
          purchasing_supplier: 0,
          sale_client: 0,
          sale_seller: 0,
        },
      },
    };
  },
  computed: {
    purchaseShow() {
      let obj = this.firstPageDataList.purchase;
      for (const key in obj) {
        if (Object.hasOwnProperty.call(obj, key)) {
          const element = obj[key];
          if (element == 1) return true;
        }
      }
      return false;
    },
    inventoryShow() {
      let obj = this.firstPageDataList.inventory;
      for (const key in obj) {
        if (Object.hasOwnProperty.call(obj, key)) {
          const element = obj[key];
          if (element == 1) return true;
        }
      }
      return false;
    },
    salesShow() {
      let obj = this.firstPageDataList.sales;
      for (const key in obj) {
        if (Object.hasOwnProperty.call(obj, key)) {
          const element = obj[key];
          if (element == 1) return true;
        }
      }
      return false;
    },
    statisticsShow() {
      let obj = this.firstPageDataList.statistics;
      for (const key in obj) {
        if (Object.hasOwnProperty.call(obj, key)) {
          const element = obj[key];
          if (element == 1) return true;
        }
      }
      return false;
    },
    trainShow() {
      let obj = this.firstPageDataList.train;
      for (const key in obj) {
        if (Object.hasOwnProperty.call(obj, key)) {
          const element = obj[key];
          if (element == 1) return true;
        }
      }
      return false;
    },
  },
  methods: {
    getUserToken() {
      this.queryObj = this.$getQueryData();
      let code = this.queryObj.code;
      if (code) {
        this.$post(this.$api.stGetUserToken, { code }).then((res) => {
          // 重置url
          history.replaceState({}, "", SERVER);
          // 保存到 Cookie
          Cookies.set("sto_user_token", res.data.token, { expires: 1, domain: "ht-tek.com" });
          // 保存到 token
          window.localStorage.setItem("sto_user_token", res.data.token);
          let redirectUrl = window.localStorage.getItem("redirect_url");
          console.log(redirectUrl);
          /**
           * 若redirectUrl
           * 为https://st.toasin.cn/ 或 https://st.toasin.cn/index
           * 则不进行跳转
           * */
          let flag =
            redirectUrl == REDIRECT_URI || redirectUrl == REDIRECT_URI + "/" || redirectUrl == REDIRECT_URI + "/index";
          if (redirectUrl && !flag) {
            window.location.href = redirectUrl;
            window.localStorage.removeItem("redirect_url");
            return;
          }
          window.localStorage.removeItem("redirect_url");
          // 获取到token后 发起请求获取权限列表
          this.infoFirstPage();
        });
      }
    },
    async infoFirstPage() {
      let { code } = this.queryObj;
      let token = window.localStorage.getItem("sto_user_token");
      if (!token && code) return;
      let result = await this.$post(this.$api.stGetIndexFirstPage);
      console.log(result);
      this.userinfo = result.data.info;
      this.firstPageDataList = result.data.list[0];
    },
    /**
     * 跳转到培训考试应用
     */
    goToExam() {
      window.location.href = `https://exam.ht-tek.com/`;
    },
  },
  created() {
    this.getUserToken();
    this.infoFirstPage();
    window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "四通集团" });
    });
  },
  mounted() {},
};
</script>

<style scoped>
.seomain {
  background-color: #f7f4f8;
}

.userinfo_wrap {
  width: 100%;
  height: 148px;
  background-color: #51596e;
}
.userinfo_content {
  display: flex;
  align-items: center;
  padding: 27px 15px;
}
.userinfo_content .left {
  width: 70px;
  height: 70px;
}
.userinfo_content .left .avatar {
  width: 70px;
  height: 70px;
  line-height: 70px;
  font-size: 28px;
  color: #fff;
  background-color: #2a82e4;
  border-radius: 50%;
  text-align: center;
  overflow: hidden;
}
.userinfo_content .left .avatar img {
  width: 100%;
  height: 100%;
}
.userinfo_content .middle {
  display: flex;
  flex-direction: column;
  padding-left: 20px;
  flex: 1;
  height: 70px;
}
.userinfo_content .middle .name {
  padding-left: 10px;
  font-size: 18px;
  line-height: 27px;
  color: #fff;
}
.userinfo_content .middle .desc {
  box-sizing: border-box;
  display: inline-block;
  position: relative;
  top: 0;
  left: 0;
  margin-top: 8px;
  padding: 5px 11px;
  height: 26px;
  /* background-color: #00baad; */
  border-radius: 13px;
}
.userinfo_content .middle .desc span {
  background-color: #00baad;
  color: #fff;
  padding: 4px 16px;
  font-size: 12px;
  border-radius: 13px;
  transform: scale(0.8);
}
.userinfo_content .right {
  width: 40px;
  height: 40px;
  text-align: center;
}
.right .icon-jiantouarrow487 {
  line-height: 40px;
  font-size: 28px;
  color: #fff;
}
.options_wrap {
  padding: 18px;
}
.bt_color_y {
  padding-left: 10px;
  border-left: 3px solid #ff8d1a;
}
.bt_color_b {
  padding-left: 10px;
  border-left: 3px solid #2a82e4;
}
.bt_color_g {
  padding-left: 10px;
  border-left: 3px solid #00baad;
}
.color_y {
  color: #ff8d1a;
}
.color_b {
  color: #2a82e4;
}
.color_g {
  color: #00baad;
}
.options_wrap .title {
  line-height: 21px;
  color: #505050;
}
.options_content {
  flex-wrap: wrap;
  background-color: #fff;
  margin-top: 10px;
  margin-bottom: 20px;
  border-radius: 5px;
}

.options_content .el-col {
  height: 100px;
}
.options_content .el-col .icon_wrap {
  position: relative;
  height: 70%;
  text-align: center;
}
.icon_wrap .iconfont {
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%);
  font-size: 30px !important;
  overflow: hidden;
}
.options_content .el-col .text {
  color: #505050;
  text-align: center;
}
</style>
